/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Read_OnlyInputs */

const vi_irrigation_schedule_read_only = /** @type {(inputs: Irrigation_Schedule_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chỉ có quyền xem lịch tưới.`)
};

/**

* @param {Irrigation_Schedule_Read_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_read_only = /** @type {((inputs?: Irrigation_Schedule_Read_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Read_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_read_only(inputs)
});